import React from "react";
import Icon from "@ant-design/icons";
import { CustomIconComponentProps } from "@ant-design/icons/es/components/Icon";

function FullCompanyDashboardIcon(props: Partial<CustomIconComponentProps>) {
  return (
    <Icon
      {...props}
      component={() => (
        <svg
          width={props.width || 14}
          height={props.height || 14}
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.6094 11.9219H1.51562V0.953125C1.51562 0.875781 1.45234 0.8125 1.375 0.8125H0.390625C0.313281 0.8125 0.25 0.875781 0.25 0.953125V13.0469C0.25 13.1242 0.313281 13.1875 0.390625 13.1875H13.6094C13.6867 13.1875 13.75 13.1242 13.75 13.0469V12.0625C13.75 11.9852 13.6867 11.9219 13.6094 11.9219ZM3.0625 10.5156H4.04688C4.12422 10.5156 4.1875 10.4523 4.1875 10.375V7.84375C4.1875 7.76641 4.12422 7.70312 4.04688 7.70312H3.0625C2.98516 7.70312 2.92188 7.76641 2.92188 7.84375V10.375C2.92188 10.4523 2.98516 10.5156 3.0625 10.5156ZM5.73438 10.5156H6.71875C6.79609 10.5156 6.85938 10.4523 6.85938 10.375V4.75C6.85938 4.67266 6.79609 4.60938 6.71875 4.60938H5.73438C5.65703 4.60938 5.59375 4.67266 5.59375 4.75V10.375C5.59375 10.4523 5.65703 10.5156 5.73438 10.5156ZM8.40625 10.5156H9.39062C9.46797 10.5156 9.53125 10.4523 9.53125 10.375V6.12109C9.53125 6.04375 9.46797 5.98047 9.39062 5.98047H8.40625C8.32891 5.98047 8.26562 6.04375 8.26562 6.12109V10.375C8.26562 10.4523 8.32891 10.5156 8.40625 10.5156ZM11.0781 10.5156H12.0625C12.1398 10.5156 12.2031 10.4523 12.2031 10.375V3.34375C12.2031 3.26641 12.1398 3.20312 12.0625 3.20312H11.0781C11.0008 3.20312 10.9375 3.26641 10.9375 3.34375V10.375C10.9375 10.4523 11.0008 10.5156 11.0781 10.5156Z"
            fill={props.fill || "#262626"}
          />
        </svg>
      )}
    />
  );
}

export default FullCompanyDashboardIcon;
